module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_FI-04-7d17437ed88b503f3009602abf24f042.svg";